import { render, staticRenderFns } from "./CatalogTemplate.vue?vue&type=template&id=f75a39f4&scoped=true&"
import script from "./CatalogTemplate.vue?vue&type=script&lang=js&"
export * from "./CatalogTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CatalogTemplate.vue?vue&type=style&index=0&id=f75a39f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75a39f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VCol,VExpandTransition,VImg,VRow,VSpacer})
